module.exports = "/images/check.jpg?ef4b8839b4bacf322b8958968e117ec3";